import React, {Component} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import {mapToDDL, removeNullFields} from "../../../common/mapper";
import SimpleInput from "../../../../modules/SimpleInput";
import Api from "../../../../Services/Api";
import {FormatCurrencyWithoutSymbol} from "../../../../Services/Utils";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import * as R from "ramda";

class MasterPromoTambahUnit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {
                kodeVariant: "",
                kodeWarna: "",
                tahunProduksi: "",
                subsidiAhm: "",
                subsidiMd: "",
                subsidiDealer: "",
                diskonMinimum: "",
                nominalLevel1: "",
                nominalLevel2: "",
                nominalLevel3: "",
                nominalLevel4: "",
                nominalLevel5: "",
                nominalLevel6: "",
                nominalLevel7: "",
                nominalLevel8: "",
                dpAwal: "",
                dpAkhir: "",
                tenorAwal: "",
                tenorAkhir: "",
                jp1: "",
                jp2: "",
                jp3: "",
            },
            dataUnit: [],
            dataWarna: [],
            selectedUnit: {},
            selectedWarna: {},
            tahunProduksi: "",
            subsidiAhm: null,
            subsidiMd: null,
            subsidiDealer: null,
            diskonMinimum: null,
            nominalLevel1: null,
            nominalLevel2: null,
            nominalLevel3: null,
            nominalLevel4: null,
            nominalLevel5: null,
            nominalLevel6: null,
            nominalLevel7: null,
            nominalLevel8: null,
            dpAwal: null,
            dpAkhir: null,
            tenorAwal: null,
            tenorAkhir: null,
            jp1: null,
            jp2: null,
            jp3: null,
        }
    }

    componentDidMount = async () => {
        if (!R.isNil(this.props.initialValue)) {
            this.mapData();
            const kodeVariant = this.props.initialValue?.dataVariant?.kodeVariant;
            if (kodeVariant) {
                await this.fetchDataWarna(kodeVariant);
            }
        } else {
            this.setState({
                nominalLevel7: 999999999,
                nominalLevel8: 999999999
            })
            await this.fetchDataVariant();
        }
    };

    fetchDataVariant = async () => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant();
            if (response.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataUnit: response.data.data,
                }));
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    fetchDataWarna = async (kodeVariant) => {
        try {
            let response = await Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByParam({
                paramFilters: {
                    kodeVariant,
                }
            });
            if (response.ok) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataWarna: response.data.data,
                }));
            }
            
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handleChangeKodeVariant = (name, value) => {
        const unit = name === "kodeVariant"
            ? this.state.dataUnit.find(item => item.kodeVariant === value)
            : this.state.dataUnit.find(item => item.kodeVariant === value);
        this.setState((prevValue) => ({
            ...prevValue,
            selectedUnit: unit,
            selectedWarna: {},
        }));
        this.fetchDataWarna(unit.kodeVariant);
    }

    handleChangeKodeWarna = (name, value) => {
        if (value === "ALL") {
            this.setState({
                selectedWarna: { kodeWarna: "ALL", namaWarnaKomersil: "ALL" }
            });
        } else {
            const warna = this.state.dataWarna.find(w => w.kodeWarna === value);
            if (warna) {
                this.setState({ selectedWarna: warna });
            }
        }
    };

    handleChangeStateNumber = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: parseFloat(value),
        }))
    }

    handleChangeState = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }))
    };

    checkErrorNumber = (value) => {
        let {isNil} = R;
        return value < 0 || isNaN(value) || isNil(value);
    };

    checkValue = () => {
        let promoType = this.props.controls.promoType?.value?.value || "CASH";
        const {
            selectedUnit, selectedWarna, tahunProduksi, subsidiAhm,
            subsidiMd, subsidiDealer, diskonMinimum, nominalLevel1,
            nominalLevel2, nominalLevel3, nominalLevel4, nominalLevel5,
            nominalLevel6, nominalLevel7, nominalLevel8, dpAwal,
            dpAkhir, tenorAwal, tenorAkhir, jp1,
            jp2, jp3,
        } = this.state;
        if (R.isEmpty(selectedUnit) || R.isEmpty(selectedWarna) || tahunProduksi.trim() === "" || this.checkErrorNumber(subsidiAhm) ||
            this.checkErrorNumber(subsidiMd) || this.checkErrorNumber(subsidiDealer) || this.checkErrorNumber(diskonMinimum) ||
            this.checkErrorNumber(diskonMinimum) || this.checkErrorNumber(nominalLevel1) || this.checkErrorNumber(nominalLevel2) ||
            this.checkErrorNumber(nominalLevel3) || this.checkErrorNumber(nominalLevel4) || this.checkErrorNumber(nominalLevel5) ||
            this.checkErrorNumber(nominalLevel6) || this.checkErrorNumber(nominalLevel7) || this.checkErrorNumber(nominalLevel8) ||
            (promoType === "CREDIT" && (this.checkErrorNumber(dpAwal) || this.checkErrorNumber(dpAkhir) || this.checkErrorNumber(tenorAwal) ||
                this.checkErrorNumber(tenorAkhir) || this.checkErrorNumber(jp1) || this.checkErrorNumber(jp2) || this.checkErrorNumber(jp3)))) {
            this.setState((prevState) => ({
                ...prevState,
                errors: {
                    ...(R.isEmpty(selectedUnit) ? {kodeVariant: "Field harus diisi"} : {}),
                    ...(R.isEmpty(selectedWarna) ? {kodeWarna: "Field harus diisi"} : {}),
                    ...(tahunProduksi.trim() === "" ? {tahunProduksi: "Field harus diisi"} : {}),
                    ...(this.checkErrorNumber(subsidiAhm) ? {subsidiAhm: "Field harus diisi"} : {}),
                    ...(this.checkErrorNumber(subsidiMd) ? {subsidiMd: "Field harus diisi"} : {}),
                    ...(this.checkErrorNumber(subsidiDealer) ? {subsidiDealer: "Field harus diisi"} : {}),
                    ...(this.checkErrorNumber(diskonMinimum) ? {diskonMinimum: "Field harus diisi"} : {}),
                    ...(this.checkErrorNumber(nominalLevel1) ? {nominalLevel1: "Field harus diisi"} : {}),
                    ...(this.checkErrorNumber(nominalLevel2) ? {nominalLevel2: "Field harus diisi"} : {}),
                    ...(this.checkErrorNumber(nominalLevel3) ? {nominalLevel3: "Field harus diisi"} : {}),
                    ...(this.checkErrorNumber(nominalLevel4) ? {nominalLevel4: "Field harus diisi"} : {}),
                    ...(this.checkErrorNumber(nominalLevel5) ? {nominalLevel5: "Field harus diisi"} : {}),
                    ...(this.checkErrorNumber(nominalLevel6) ? {nominalLevel6: "Field harus diisi"} : {}),
                    ...(this.checkErrorNumber(nominalLevel7) ? {nominalLevel7: "Field harus diisi"} : {}),
                    ...(this.checkErrorNumber(nominalLevel8) ? {nominalLevel8: "Field harus diisi"} : {}),
                    ...(promoType === "CREDIT" && this.checkErrorNumber(jp1) ? {jp1: "Field harus diisi"} : {}),
                    ...(promoType === "CREDIT" && this.checkErrorNumber(jp2) ? {jp2: "Field harus diisi"} : {}),
                    ...(promoType === "CREDIT" && this.checkErrorNumber(jp3) ? {jp3: "Field harus diisi"} : {}),
                    ...(promoType === "CREDIT" && this.checkErrorNumber(dpAwal) ? {dpAwal: "Field harus diisi"} : {}),
                    ...(promoType === "CREDIT" && this.checkErrorNumber(dpAkhir) ? {dpAkhir: "Field harus diisi"} : {}),
                    ...(promoType === "CREDIT" && this.checkErrorNumber(tenorAwal) ? {tenorAwal: "Field harus diisi"} : {}),
                    ...(promoType === "CREDIT" && this.checkErrorNumber(tenorAkhir) ? {tenorAkhir: "Field harus diisi"} : {}),
                }
            }))
            return false;
        }
        return true;
    };

    // handleSubmit = () => {
    //     if (this.checkValue() === true) {
    //         const added = removeNullFields({
    //             dataVariant: this.state.selectedUnit,
    //             dataWarna: this.state.selectedWarna,
    //             tahunProduksi: this.state.tahunProduksi,
    //             subsidiAhm: this.state.subsidiAhm,
    //             subsidiMd: this.state.subsidiMd,
    //             subsidiDealer: this.state.subsidiDealer,
    //             diskonMinimum: this.state.diskonMinimum,
    //             nominalLevel1: this.state.nominalLevel1,
    //             nominalLevel2: this.state.nominalLevel2,
    //             nominalLevel3: this.state.nominalLevel3,
    //             nominalLevel4: this.state.nominalLevel4,
    //             nominalLevel5: this.state.nominalLevel5,
    //             nominalLevel6: this.state.nominalLevel6,
    //             nominalLevel7: this.state.nominalLevel7,
    //             nominalLevel8: this.state.nominalLevel8,
    //             jp1: this.state.jp1,
    //             jp2: this.state.jp2,
    //             jp3: this.state.jp3,
    //             dpAwal: this.state.dpAwal,
    //             dpAkhir: this.state.dpAkhir,
    //             tenorAwal: this.state.tenorAwal,
    //             tenorAkhir: this.state.tenorAkhir,
    //         });
    //         this.props.onSubmit(added);
    //     }
    // };

    handleSubmit = () => {
        if (this.checkValue() === true) {
            if (this.state.selectedWarna?.kodeWarna === "ALL") {
                const payloads = this.state.dataWarna.map((warna) => removeNullFields({
                    dataVariant: this.state.selectedUnit,
                    dataWarna: warna,
                    tahunProduksi: this.state.tahunProduksi,
                    subsidiAhm: this.state.subsidiAhm,
                    subsidiMd: this.state.subsidiMd,
                    subsidiDealer: this.state.subsidiDealer,
                    diskonMinimum: this.state.diskonMinimum,
                    nominalLevel1: this.state.nominalLevel1,
                    nominalLevel2: this.state.nominalLevel2,
                    nominalLevel3: this.state.nominalLevel3,
                    nominalLevel4: this.state.nominalLevel4,
                    nominalLevel5: this.state.nominalLevel5,
                    nominalLevel6: this.state.nominalLevel6,
                    nominalLevel7: this.state.nominalLevel7,
                    nominalLevel8: this.state.nominalLevel8,
                    jp1: this.state.jp1,
                    jp2: this.state.jp2,
                    jp3: this.state.jp3,
                    dpAwal: this.state.dpAwal,
                    dpAkhir: this.state.dpAkhir,
                    tenorAwal: this.state.tenorAwal,
                    tenorAkhir: this.state.tenorAkhir,
                }));
            
                this.props.onSubmit(payloads);
            
            } else {
                const payload = removeNullFields({
                    dataVariant: this.state.selectedUnit,
                    dataWarna: this.state.selectedWarna,
                    tahunProduksi: Number(this.state.tahunProduksi),
                    subsidiAhm: this.state.subsidiAhm,
                    subsidiMd: this.state.subsidiMd,
                    subsidiDealer: this.state.subsidiDealer,
                    diskonMinimum: this.state.diskonMinimum,
                    nominalLevel1: this.state.nominalLevel1,
                    nominalLevel2: this.state.nominalLevel2,
                    nominalLevel3: this.state.nominalLevel3,
                    nominalLevel4: this.state.nominalLevel4,
                    nominalLevel5: this.state.nominalLevel5,
                    nominalLevel6: this.state.nominalLevel6,
                    nominalLevel7: this.state.nominalLevel7,
                    nominalLevel8: this.state.nominalLevel8,
                    jp1: this.state.jp1,
                    jp2: this.state.jp2,
                    jp3: this.state.jp3,
                    dpAwal: this.state.dpAwal,
                    dpAkhir: this.state.dpAkhir,
                    tenorAwal: this.state.tenorAwal,
                    tenorAkhir: this.state.tenorAkhir,
                });
        
                this.props.onSubmit([payload]);
            }
        }
    };



    // mapData = () => {
    //     let data = {};
    //     let initialData = this.props.initialValue;
    //     let promoType = this.props.controls.promoType?.value;
    //     data.selectedUnit = initialData.dataVariant;
    //     data.selectedWarna = initialData.dataWarna;
    //     data.tahunProduksi = initialData.tahunProduksi.toString();
    //     data.subsidiAhm = initialData.subsidiAhm;
    //     data.subsidiMd = initialData.subsidiMd;
    //     data.subsidiDealer = initialData.subsidiDealer;
    //     data.diskonMinimum = initialData.diskonMinimum;
    //     data.nominalLevel1 = initialData.nominalLevel1;
    //     data.nominalLevel2 = initialData.nominalLevel2;
    //     data.nominalLevel3 = initialData.nominalLevel3;
    //     data.nominalLevel4 = initialData.nominalLevel4;
    //     data.nominalLevel5 = initialData.nominalLevel5;
    //     data.nominalLevel6 = initialData.nominalLevel6;
    //     data.nominalLevel7 = initialData.nominalLevel7;
    //     data.nominalLevel8 = initialData.nominalLevel8;
    //     if (promoType?.value === "CREDIT") {
    //         data.jp1 = initialData.jp1;
    //         data.jp2 = initialData.jp2;
    //         data.jp3 = initialData.jp3;
    //         data.dpAwal = initialData.dpAwal;
    //         data.dpAkhir = initialData.dpAkhir;
    //         data.tenorAwal = initialData.tenorAwal;
    //         data.tenorAkhir = initialData.tenorAkhir;
    //     }
    //     console.log("data", data);
    //     this.setState((prevState) => ({
    //         ...prevState,
    //         ...data,
    //     }))
    // };

    mapData = () => {
        let data = {};
        let initialData = this.props.initialValue;
        let promoType = this.props.controls.promoType?.value;

        data.selectedUnit = initialData.dataVariant || null;
        data.selectedWarna = initialData.dataWarna || null;   // <-- pastikan default null
        data.tahunProduksi = initialData.tahunProduksi?.toString() || "";
        data.subsidiAhm = initialData.subsidiAhm || 0;
        data.subsidiMd = initialData.subsidiMd || 0;
        data.subsidiDealer = initialData.subsidiDealer || 0;
        data.diskonMinimum = initialData.diskonMinimum || 0;
        data.nominalLevel1 = initialData.nominalLevel1 || 0;
        data.nominalLevel2 = initialData.nominalLevel2 || 0;
        data.nominalLevel3 = initialData.nominalLevel3 || 0;
        data.nominalLevel4 = initialData.nominalLevel4 || 0;
        data.nominalLevel5 = initialData.nominalLevel5 || 0;
        data.nominalLevel6 = initialData.nominalLevel6 || 0;
        data.nominalLevel7 = initialData.nominalLevel7 || 0;
        data.nominalLevel8 = initialData.nominalLevel8 || 0;

        if (promoType?.value === "CREDIT") {
            data.jp1 = initialData.jp1 || 0;
            data.jp2 = initialData.jp2 || 0;
            data.jp3 = initialData.jp3 || 0;
            data.dpAwal = initialData.dpAwal || 0;
            data.dpAkhir = initialData.dpAkhir || 0;
            data.tenorAwal = initialData.tenorAwal || 0;
            data.tenorAkhir = initialData.tenorAkhir || 0;
        }

        this.setState((prevState) => ({
            ...prevState,
            ...data,
        }));
    };

    render() {
        let {promoType} = this.props.controls;
        let {isNil} = R;
        let {
            subsidiAhm,
            subsidiMd, subsidiDealer, diskonMinimum, nominalLevel1,
            nominalLevel2, nominalLevel3, nominalLevel4, nominalLevel5,
            nominalLevel6, nominalLevel7, nominalLevel8, dpAwal,
            dpAkhir, tenorAwal, tenorAkhir, jp1,
            jp2, jp3,
        } = this.state;
        return (
            <SimpleModal
                title="Master Promo Detail - Tambah Unit"
                visible={this.props.visible}
                onClickClose={this.props.onClickClose}
                styles={{width: "50%"}}
                content={
                    <ModalContainer>
                        <FlexView column>
                            <div className="grid grid-3x gap-20px">
                                <div id="grid-1">
                                    <SimpleDDL
                                        id="select-options-kode-variant"
                                        name="kodeVariant"
                                        label="Kode Varian"
                                        box="search"
                                        value={
                                            {
                                                value: this.state.selectedUnit?.kodeVariant,
                                                label: this.state.selectedUnit?.kodeVariant
                                            }
                                            || {}
                                        }
                                        mandatory
                                        errorMessage={this.state.errors.kodeVariant}
                                        options={this.state.dataUnit.map(item => mapToDDL(item.kodeVariant, item.kodeVariant))}
                                        onChange={(value, {name}) => this.handleChangeKodeVariant(name, value.value)}
                                    />
                                    <SimpleDDL
                                        id="select-options-nama-variant"
                                        name="namaVariant"
                                        label="Nama Varian"
                                        box="search"
                                        mandatory
                                        value={
                                            {
                                                value: this.state.selectedUnit?.kodeVariant,
                                                label: this.state.selectedUnit?.namaVariant
                                            }
                                            || {}
                                        }
                                        errorMessage={this.state.errors.kodeVariant}
                                        options={this.state.dataUnit.map(item => mapToDDL(item.namaVariant, item.kodeVariant))}
                                        onChange={(value, {name}) => this.handleChangeKodeVariant(name, value.value)}
                                    />
                                </div>
                                <div id="grid-2">
                                    <SimpleInput
                                        name="tahunProduksi"
                                        label="Tahun Produksi"
                                        mandatory
                                        value={this.state.tahunProduksi}
                                        errorMessage={this.state.errors.tahunProduksi}
                                        onChange={({target}) => this.handleChangeState(target.name, target.value)}
                                    />
                                    <SimpleDDL
                                        id="select-options-kode-warna"
                                        name="kodeWarna"
                                        label="Kode Warna"
                                        box="search"
                                        value={
                                            this.state.selectedWarna
                                                ? {
                                                    value: this.state.selectedWarna.kodeWarna,
                                                    label: this.state.selectedWarna.kodeWarna,
                                                }
                                                : null 
                                        }
                                        mandatory
                                        errorMessage={this.state.errors.kodeWarna}
                                        options={[
                                            ...(this.state.dataWarna.length > 0
                                                ? [mapToDDL("ALL", "ALL")]
                                                : []),
                                            ...this.state.dataWarna.map(item =>
                                                mapToDDL(item.kodeWarna, item.kodeWarna)
                                            ),
                                        ]}
                                        onChange={(value, { name }) =>
                                            this.handleChangeKodeWarna(name, value.value)
                                        }
                                    />
                                </div>
                                <div id="grid-3">
                                    <SimpleDDL
                                        id="select-options-nama-warna"
                                        name="namaWarnaKomersil"
                                        label="Nama Warna"
                                        box="search"
                                        mandatory
                                        value={
                                            this.state.selectedWarna
                                                ? {
                                                    value: this.state.selectedWarna.kodeWarna,
                                                    label: this.state.selectedWarna.namaWarnaKomersil,
                                                }
                                                : null 
                                        }
                                        errorMessage={this.state.errors.kodeWarna}
                                        options={[
                                            ...(this.state.dataWarna.length > 0
                                                ? [mapToDDL("ALL", "ALL")]
                                                : []),
                                            ...this.state.dataWarna.map(item =>
                                                mapToDDL(item.namaWarnaKomersil, item.kodeWarna)
                                            ),
                                        ]}
                                        onChange={(value, { name }) =>
                                            this.handleChangeKodeWarna(name, value.value)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="grid grid-3x gap-20px">
                                <div id="grid-1">
                                    <SimpleInput
                                        name="subsidiAhm"
                                        label="Subsidi AHM"
                                        box="number"
                                        mandatory
                                        errorMessage={this.state.errors.subsidiAhm}
                                        value={isNil(subsidiAhm) ? subsidiAhm : FormatCurrencyWithoutSymbol({number: subsidiAhm})}
                                        onValueChange={({value}) => this.handleChangeStateNumber("subsidiAhm", value)}
                                    />
                                </div>
                                <div id="grid-2">
                                    <SimpleInput
                                        name="subsidiMd"
                                        label="Subsidi MD"
                                        box="number"
                                        mandatory
                                        errorMessage={this.state.errors.subsidiMd}
                                        value={isNil(subsidiMd) ? subsidiMd : FormatCurrencyWithoutSymbol({number: this.state.subsidiMd})}
                                        onValueChange={({value}) => this.handleChangeStateNumber("subsidiMd", value)}
                                    />
                                </div>
                                <div id="grid-3">
                                    <SimpleInput
                                        name="subsidiDealer"
                                        label="Subsidi Dealer"
                                        box="number"
                                        mandatory
                                        errorMessage={this.state.errors.subsidiDealer}
                                        value={isNil(subsidiDealer) ? subsidiDealer : FormatCurrencyWithoutSymbol({number: this.state.subsidiDealer})}
                                        onValueChange={({value}) => this.handleChangeStateNumber("subsidiDealer", value)}
                                    />
                                </div>
                            </div>
                            <div className="grid grid-3x gap-20px">
                                <div id="grid-1">
                                    <SimpleInput
                                        name="diskonMinimum"
                                        label="Diskon Minimum"
                                        box="number"
                                        mandatory
                                        errorMessage={this.state.errors.diskonMinimum}
                                        value={isNil(diskonMinimum) ? diskonMinimum : FormatCurrencyWithoutSymbol({number: this.state.diskonMinimum})}
                                        onValueChange={({value}) => this.handleChangeStateNumber("diskonMinimum", value)}
                                    />
                                    <SimpleInput
                                        name="nominalLevel1"
                                        label="Level 1"
                                        box="number"
                                        mandatory
                                        errorMessage={this.state.errors.nominalLevel1}
                                        value={isNil(nominalLevel1) ? nominalLevel1 : FormatCurrencyWithoutSymbol({number: this.state.nominalLevel1})}
                                        onValueChange={({value}) => this.handleChangeStateNumber("nominalLevel1", value)}
                                    />
                                    <SimpleInput
                                        name="nominalLevel2"
                                        label="Level 2"
                                        box="number"
                                        mandatory
                                        errorMessage={this.state.errors.nominalLevel2}
                                        value={isNil(nominalLevel2) ? nominalLevel2 : FormatCurrencyWithoutSymbol({number: this.state.nominalLevel2})}
                                        onValueChange={({value}) => this.handleChangeStateNumber("nominalLevel2", value)}
                                    />
                                    <SimpleInput
                                        name="nominalLevel3"
                                        label="Level 3"
                                        box="number"
                                        mandatory
                                        errorMessage={this.state.errors.nominalLevel3}
                                        value={isNil(nominalLevel3) ? nominalLevel3 : FormatCurrencyWithoutSymbol({number: this.state.nominalLevel3})}
                                        onValueChange={({value}) => this.handleChangeStateNumber("nominalLevel3", value)}
                                    />
                                    <SimpleInput
                                        name="nominalLevel4"
                                        label="Level 4"
                                        box="number"
                                        mandatory
                                        errorMessage={this.state.errors.nominalLevel4}
                                        value={isNil(nominalLevel4) ? nominalLevel4 : FormatCurrencyWithoutSymbol({number: this.state.nominalLevel4})}
                                        onValueChange={({value}) => this.handleChangeStateNumber("nominalLevel4", value)}
                                    />
                                </div>
                                <div id="grid-2">
                                    <div style={{height: "83px"}}/>
                                    <SimpleInput
                                        name="nominalLevel5"
                                        label="Level 5"
                                        box="number"
                                        mandatory
                                        errorMessage={this.state.errors.nominalLevel5}
                                        value={isNil(nominalLevel5) ? nominalLevel5 : FormatCurrencyWithoutSymbol({number: this.state.nominalLevel5})}
                                        onValueChange={({value}) => this.handleChangeStateNumber("nominalLevel5", value)}
                                    />
                                    <SimpleInput
                                        name="nominalLevel6"
                                        label="Level 6"
                                        box="number"
                                        mandatory
                                        errorMessage={this.state.errors.nominalLevel6}
                                        value={isNil(nominalLevel6) ? nominalLevel6 : FormatCurrencyWithoutSymbol({number: this.state.nominalLevel6})}
                                        onValueChange={({value}) => this.handleChangeStateNumber("nominalLevel6", value)}
                                    />
                                    <SimpleInput
                                        name="nominalLevel7"
                                        label="Level 7"
                                        box="number"
                                        mandatory
                                        errorMessage={this.state.errors.nominalLevel7}
                                        value={isNil(nominalLevel7) ? nominalLevel7 : FormatCurrencyWithoutSymbol({number: this.state.nominalLevel7})}
                                        onValueChange={({value}) => this.handleChangeStateNumber("nominalLevel7", value)}
                                    />
                                    <SimpleInput
                                        name="nominalLevel8"
                                        label="Level 8"
                                        box="number"
                                        mandatory
                                        errorMessage={this.state.errors.nominalLevel8}
                                        value={isNil(nominalLevel8) ? nominalLevel8 : FormatCurrencyWithoutSymbol({number: this.state.nominalLevel8})}
                                        onValueChange={({value}) => this.handleChangeStateNumber("nominalLevel8", value)}
                                    />
                                </div>
                                {promoType.value?.value === "CREDIT" && (
                                    <div id="grid-3">
                                        <div className="grid grid-2x gap-20px">
                                            <div id="grid-1">
                                                <SimpleInput
                                                    name="dpAwal"
                                                    label="Dp Awal"
                                                    box="number"
                                                    mandatory={promoType.value?.value === "CREDIT"}
                                                    errorMessage={this.state.errors.dpAwal}
                                                    value={isNil(dpAwal) ? dpAwal : FormatCurrencyWithoutSymbol({number: this.state.dpAwal})}
                                                    onValueChange={({value}) => this.handleChangeStateNumber("dpAwal", value)}
                                                />
                                                <SimpleInput
                                                    name="tenorAwal"
                                                    label="Tenor Awal"
                                                    box="number"
                                                    mandatory={promoType.value?.value === "CREDIT"}
                                                    errorMessage={this.state.errors.tenorAwal}
                                                    value={isNil(tenorAwal) ? tenorAwal : FormatCurrencyWithoutSymbol({number: this.state.tenorAwal})}
                                                    onValueChange={({value}) => this.handleChangeStateNumber("tenorAwal", value)}
                                                />
                                            </div>
                                            <div id="grid-2">
                                                <SimpleInput
                                                    name="dpAkhir"
                                                    label="Dp Akhir"
                                                    box="number"
                                                    mandatory={promoType.value?.value === "CREDIT"}
                                                    errorMessage={this.state.errors.dpAkhir}
                                                    value={isNil(dpAkhir) ? dpAkhir : FormatCurrencyWithoutSymbol({number: this.state.dpAkhir})}
                                                    onValueChange={({value}) => this.handleChangeStateNumber("dpAkhir", value)}
                                                />
                                                <SimpleInput
                                                    name="tenorAkhir"
                                                    label="Tenor Akhir"
                                                    box="number"
                                                    mandatory={promoType.value?.value === "CREDIT"}
                                                    errorMessage={this.state.errors.tenorAkhir}
                                                    value={isNil(tenorAkhir) ? tenorAkhir : FormatCurrencyWithoutSymbol({number: this.state.tenorAkhir})}
                                                    onValueChange={({value}) => this.handleChangeStateNumber("tenorAkhir", value)}
                                                />
                                            </div>
                                        </div>
                                        <SimpleInput
                                            name="jp1"
                                            label="JP1"
                                            box="number"
                                            mandatory={promoType.value?.value === "CREDIT"}
                                            errorMessage={this.state.errors.jp1}
                                            value={isNil(jp1) ? jp1 : FormatCurrencyWithoutSymbol({number: this.state.jp1})}
                                            onValueChange={({value}) => this.handleChangeStateNumber("jp1", value)}
                                        />
                                        <SimpleInput
                                            name="jp2"
                                            label="JP2"
                                            box="number"
                                            mandatory={promoType.value?.value === "CREDIT"}
                                            errorMessage={this.state.errors.jp2}
                                            value={isNil(jp2) ? jp2 : FormatCurrencyWithoutSymbol({number: this.state.jp2})}
                                            onValueChange={({value}) => this.handleChangeStateNumber("jp2", value)}
                                        />
                                        <SimpleInput
                                            name="jp3"
                                            label="JP3"
                                            box="number"
                                            mandatory={promoType.value?.value === "CREDIT"}
                                            errorMessage={this.state.errors.jp3}
                                            value={isNil(jp3) ? jp3 : FormatCurrencyWithoutSymbol({number: this.state.jp3})}
                                            onValueChange={({value}) => this.handleChangeStateNumber("jp3", value)}
                                        />
                                    </div>
                                )}
                            </div>
                        </FlexView>
                        <FlexView style={{justifyContent: "center"}}>
                            <SimpleButton
                                onClick={this.handleSubmit}
                            >SIMPAN</SimpleButton>
                        </FlexView>

                    </ModalContainer>
                }
            />
        )
    }
}

export default MasterPromoTambahUnit;
